module.exports = __webpack_public_path__ + "static/media/lend.55073bc6.svg";